/**
 * Open the Intercom chat via a link or URL.
 *
 * Usage:
 * - Link to "#chat" (same page, no reload) or "/contact/#chat" (other page)
 * - "?chat" also works: "/contact/?chat"
 */

const CHAT_HASH = '#chat';
const CHAT_PARAM = 'chat';
const MAX_WAIT_MS = 10000;
const POLL_MS = 200;

function isChatUrl(url) {
    return url.hash === CHAT_HASH || url.searchParams.has(CHAT_PARAM);
}

// Intercom may load late (plugin / GTM), so wait until it's available
function openChat() {
    const start = Date.now();

    const tryOpen = () => {
        // The Intercom snippet defines a queueing stub, so calls before load are processed later
        if (typeof window.Intercom === 'function') {
            window.Intercom('show');
            return;
        }
        if (Date.now() - start < MAX_WAIT_MS) {
            setTimeout(tryOpen, POLL_MS);
        }
    };

    tryOpen();
}

function cleanUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete(CHAT_PARAM);
    if (url.hash === CHAT_HASH) {
        url.hash = '';
    }
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
}

// Links on the current page
document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) {
        return;
    }

    const url = new URL(link.href, window.location.href);
    if (!isChatUrl(url)) {
        return;
    }

    // Only intercept links to the current page; others navigate and open on load
    const samePage = url.origin === window.location.origin && url.pathname === window.location.pathname;
    if (!samePage) {
        return;
    }

    event.preventDefault();
    openChat();
});

// Arriving via a chat URL
if (isChatUrl(new URL(window.location.href))) {
    cleanUrl();
    openChat();
}
